import classNames from 'classnames';
import React from 'react';
import { useTranslation } from '../../../../i18n/use-translation';
import { ChooseRoleItemProps } from './type/props';
import * as styles from './ChooseRoleItem.module.sass';
import { Image } from '../../../atoms/image';

export const ChooseRoleItem = React.memo((props: ChooseRoleItemProps) => {
  const { t } = useTranslation();

  return (
    <li onClick={() => props.onClick(props.item.key)} className={styles.modal_register_role__item}>
      <Image
        srcs={[{ src: props.item.image.src, type: props.item.image.type }]}
        src={props.item.image.src}
        alt={t(props.item.title)}
      />
      <div className={styles.register_modal_text}>
        <p className={styles.register_text_header}>{t(props.item.title)}</p>
        <p className={styles.register_text_description}>{t(props.item.description)}</p>
        <button className={styles.register_button}>
          <span className={classNames(styles.long_arrow_right, 'register-button')}></span>
        </button>
      </div>
    </li>
  );
});
